export const locationOverlay = {
  choose_an_address: 'Choose an address',
  no_saved_addresses: 'You have no saved addresses',
  add_new_address: 'Add a new address',
}
